import React, { useEffect, useState } from 'react';
import OrderLoadForm from 'components/OrderReturns/OrderLoadForm';
import { useSelector } from 'react-redux';
import OrderReturnSubmitForm from 'components/OrderReturns/OrderReturnSubmitForm';
import { getIsLoggedIn } from 'hooks/useAuth';

export interface ITranslations {
    explanation: string;
    orderNumber: string;
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
    reason: string;
    bankAccount: string;
    bankAccountPlaceholder: string;
    returnableProducts: string;
    columnProduct: string;
    columnQuantity: string;
    columnSum: string;
    confirmReturn: string;
    submitReturn: string;
    successTitle: string;
    successText: string;
    myAccount: string;
    errorRequired: string;
    errorName: string;
    errorEmail: string;
    errorPhone: string;
    errorCheckData: string;
    errorSelectProduct: string;
    errorLoadFailed: string;
    loadOrder: string;
    orderLoaded: string;
    orderLoadedPrefix: string;
    orderLoadedSuffix: string;
}
export interface IReturnCustomer {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

export interface IReturnOrder {
    orderNumber: string;
    products: IReturnProduct[];
    customer: IReturnCustomer;
}

export interface IOrderItem {
    id: string;
    sku: string;
    name: string;
    price: number;
    orderedQuantity: number;
}

export interface IReturnProduct extends IOrderItem {
    returnQuantity: number;
    selected: boolean;
}

interface IProps {
    config: {
        defaultPhonePrefix: string;
        phonePrefixes: string[];
        accountUrl: string;
        labels: ITranslations;
    };
}

const mapStateToProps = (state) => {
    return {
        order: state.entities.orderReturn as IReturnOrder,
    };
};

const ReturnForm = (props: IProps) => {
    const { labels, defaultPhonePrefix, phonePrefixes, accountUrl } = props.config;
    const { order } = useSelector(mapStateToProps);
    const [submitted, setSubmitted] = useState(false);
    const isLoggedIn = getIsLoggedIn();

    useEffect(() => {
        if (submitted) {
            window.scrollTo(0, 0);
        }
    }, [submitted]);

    if (submitted) {
        return (
            <div className="box-promo align-vertical-center">
                <div className="box-promo__text">
                    <h1>{labels.successTitle}</h1>
                    <p>{labels.successText}</p>
                    {isLoggedIn && (
                        <p className="box-promo__actions">
                            <a href={accountUrl} className="primary">
                                {labels.myAccount}
                            </a>
                        </p>
                    )}
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <OrderLoadForm labels={labels} defaultPhonePrefix={defaultPhonePrefix} phonePrefixes={phonePrefixes} />
            {order && <OrderReturnSubmitForm labels={labels} order={order} setSubmitted={setSubmitted} />}
        </React.Fragment>
    );
};
export default ReturnForm;
